PREFIX ccf: <http://purl.org/ccf/>
PREFIX HRApop: <https://purl.humanatlas.io/graph/hra-pop>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX UBERON: <http://purl.obolibrary.org/obo/UBERON_>
PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT ?cell_source_type ?cell_source ?cell_source_label ?cell_source_link ?tool ?modality ?cell_id
  ?percentage
FROM HRA:
FROM HRApop:
WHERE {
  {
    #{{VALUES}}
    #{{TOOLS}}
    ?cell_source ccf:has_cell_summary [ ccf:has_cell_summary_row [ ccf:cell_id ?cell_id ;
         ccf:cell_label ?cell_label ;
         ccf:percentage_of_total ?percentage ] ] .
  }
  OPTIONAL {
    ?cell_source ccf:has_cell_summary [ ccf:cell_annotation_method ?tool ;
         ccf:modality ?modality ] .
  }
  OPTIONAL {
    ?cell_source rdfs:label ?cell_source_label .
  }
  OPTIONAL {
    ?cell_source ccf:url ?cell_source_link .
  }
  {
    #{{ORGAN_IRIs}}
    # Anatomical Structure cell sources
    [] ccf:representation_of ?cell_source ;
       ccf:has_reference_organ ?refOrgan .
    VALUES (?cell_source_type) { (ccf:AnatomicalStructure) }
  }
  UNION
  {
    {
      # Dataset cell sources
      ?block ccf:has_registration_location ?rui_location .
      ?block ccf:generates_dataset ?cell_source .
    }
    UNION
    {
      ?block ccf:subdivided_into_sections ?section .
      ?block ccf:has_registration_location ?rui_location .
      ?section ccf:generates_dataset ?cell_source .
    }
    [] a ccf:SpatialPlacement ;
       ccf:placement_for ?rui_location ;
       ccf:placement_relative_to ?refOrgan .
    VALUES (?cell_source_type) { (ccf:Dataset) }
  }
  UNION
  {
    # RUI Location cell sources
    [] a ccf:SpatialPlacement ;
       ccf:placement_for ?cell_source ;
       ccf:placement_relative_to ?refOrgan .
    VALUES (?cell_source_type) { (ccf:SpatialEntity) }
  }
  ?refOrgan ccf:representation_of [ ccf:ccf_part_of* ?organ_iri ] .
}
